import React from 'react';
import './ContactsPage.css';

const EMAIL = 'sinaure@gmail.com';
const LINKEDIN_URL = 'https://www.linkedin.com/in/asinatrasophiaantipolis/';

function ContactsPage() {
  return (
    <div className="contacts-page page-content">
      <header className="contacts-header">
        <h2 className="contacts-title">Contact</h2>
        <p className="contacts-lead">
          Questions about Sophiatrading, data, or the platform — reach out anytime.
        </p>
      </header>

      <ul className="contacts-list">
        <li className="contacts-item">
          <span className="contacts-label">Email</span>
          <a className="contacts-link" href={`mailto:${EMAIL}`}>
            {EMAIL}
          </a>
        </li>
        <li className="contacts-item">
          <span className="contacts-label">LinkedIn</span>
          <a
            className="contacts-link"
            href={LINKEDIN_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            asinatrasophiaantipolis
          </a>
        </li>
      </ul>
    </div>
  );
}

export default ContactsPage;
